import React, { useState, useEffect, useRef } from 'react';
import { Container, Row, Col, Form, Button, Spinner, Alert, Card ,Table} from 'react-bootstrap';
import { useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import { getAllProduct } from "../product/productAction";
import { getAllServiceType } from "../serviceType/serviceTypeAction";
import { getAllTourType } from "../tourTypes/TourTypeAction";
import { getAllMainSubProduct } from "../subproduct/subproductAction";
import { useParams, useNavigate, Link } from 'react-router-dom';
import { newProductCommissionCreation,getAllProductCommission } from "./commissionAction";
import Swal from 'sweetalert2';
import { FaEdit, FaTrash, FaPlus, FaEye, FaArrowLeft } from 'react-icons/fa';


const CreateExcursionCommission = () => {
  const dispatch = useDispatch();
  const { name } = useParams();
  const navigate = useNavigate();

  const [product, setProduct] = useState("");
  const [productid,setProductid]= useState('');
  const [tourtypeid,setTourtypeid]= useState('');
  const [servicetypeid,setServicetypeid]= useState('');
  const { products } = useSelector((state) => state.productList);
  const { serviceType } = useSelector((state) => state.serviceTypiesList);
  const { productcomission, isLoading } = useSelector((state) => state.productcommissionList);
  const { tourType } = useSelector((state) => state.tourTypesList);
  const { subproducts2 } = useSelector((state) => state.subproductList);

  const [subproducts22, setSubproducts22] = useState([]);
  const [commissiondata, setCommissionData] = useState([]);
  console.log("cnmmmm",commissiondata)
  const [allCommission, setAllCommission] = useState("");
  const [applyToAll, setApplyToAll] = useState(false);
 

  
  
  const handleProductChange = (e) => {
    console.log("productcommission",productcomission)
    const selectedProduct = parseInt(e, 10);
    if(productcomission?.result3?.length > 0){
      const newData = productcomission?.result3?.map((user) => {
        const productcomissionData = JSON.parse(JSON.stringify(user));
        const { id, product_name, status } = productcomissionData;
    
        const productID = selectedProduct; // Product ID to detect
    
        console.log("diiiid", productID);
        console.log("diiiid", id);
        const newSubproducts = [];
    
        // Get the subproducts for product_id in table A
        const subproductsA = productcomission.result4.filter((item) => item.product_id === productID);
    
        // Get the subproducts for product_id in table B
        const subproductsB = productcomission.result1.filter((item) => item.product_id === productID);
    
        // Check if any subproduct in table A does not have a corresponding entry in table B
        subproductsA.forEach((subproductA) => {
          const subproductExistsInB = subproductsB.some((subproductB) => subproductB.subproduct_id === subproductA.id);
          if (!subproductExistsInB) {
            // Add the additional properties to the newSubproduct object
            const newSubproduct = {
              ...subproductA,
              commission: '',
              serviceTypeId: name,
              commissiontype: '',
            };
            newSubproducts.push(newSubproduct);
          }
        });
    
        return {
          productID,
          newSubproducts,
        };
      });
    
      // Update the state with the new data
      setCommissionData(newData[0]?.newSubproducts);

    }else{
      let newData = [];
  
      if (productcomission?.result4) {
        newData = productcomission.result4
          ?.filter((subproductA) => subproductA.product_id === selectedProduct)
          .map((subproductA) => {
            const newSubproduct = {
              ...subproductA,
              commission: '',
              serviceTypeId: name,
              commissiontype: '',
            };
            return newSubproduct;
          });
      }
    
      // Check if newData is empty
      if (newData.length === 0) {
        // Add logic to display all subproducts in this case
        newData = productcomission.result4?.filter((subproductA) => subproductA.product_id === selectedProduct);
      }
    
      // Update the state with the new data
      setCommissionData(newData);
    }

  };

  

  // const handleProductChange = (e) => {
  //   const selectedProduct = e;
  //   // Fetch subproducts for the selected product from the database
  //   const result = subproducts2.filter(obj => obj.product_id == selectedProduct).map((subproduct) => ({
  //       ...subproduct,
  //       commission: '',
  //       serviceTypeId: name,
  //       commissiontype: '',
  //     }));
  //   const filtersub = subproducts2.filter(obj => obj.product_id == selectedProduct);
  //   setProduct(selectedProduct);
  //   setCommissionData(result)
  //   setSubproducts22(filtersub);
  //   setAllCommission("");
  //   setApplyToAll(false);
  // };




//   const handleServtypeChange = (e) => {
//     const selectedProduct = e;
//     // Fetch subproducts for the selected product from the database
//     const filtersub = commissiondata.map((subproduct) => ({
//         ...subproduct,
//         serviceTypeId: e,
      
//       }));

//     setCommissionData(filtersub)
//     setAllCommission("");
//     setApplyToAll(false);
//   };

  
//   const handleTourtypeChange = (e) => {
//     const selectedProduct = e;
//     // Fetch subproducts for the selected product from the database
//     const filtersub = commissiondata.map((subproduct) => ({
//         ...subproduct,
//         tourType: e,
      
//       }));

//     setCommissionData(filtersub)
//     setAllCommission("");
//     setApplyToAll(false);
//   };

  const handleComtypeChange = (index,e) => {
    const selectedProduct = e;
    const newSubproducts = [...commissiondata];
    newSubproducts[index].commissiontype = e;
    // Fetch subproducts for the selected product from the database
    // const filtersub = commissiondata.map((subproduct) => ({
    //     ...subproduct,
    //     commissiontype: e,
      
    //   }));

    setCommissionData(newSubproducts)
    setAllCommission("");
    setApplyToAll(false);
  };
  useEffect(() => {
    dispatch(getAllProduct());
    dispatch(getAllServiceType());
    // dispatch(getAllTourType());
    dispatch(getAllMainSubProduct());
    dispatch(getAllProductCommission());
    
  }, []);

  const onBack  = () => {
    if(name == 'Excursion'){
      navigate('/excursionCommissionList/Excursion');

    }else if(name == 'Transfer'){
      navigate('/transferCommissionList/Transfer');
    }else if(name == 'Holiday'){
      navigate('/holidayCommissionList/Holiday');

    }
  }

  const handleApplyToAllChange = (event) => {
    const checked = event.target.checked;
    const newSubproducts = commissiondata.map((subproduct) => ({
      ...subproduct,
      commission: checked ? allCommission : subproduct.commission,
    }));
    setCommissionData(newSubproducts);
    setApplyToAll(checked);
  };

  const handleSubproductCommissionChange = (index, newCommission) => {
    const newSubproducts = [...commissiondata];
    newSubproducts[index].commission = newCommission;
    console.log("vivo",newSubproducts)
    setCommissionData(newSubproducts);
    setApplyToAll(false);
  };
  console.log("Subproducts: ", commissiondata);
  console.log("subproducts22: ", subproducts22);
  const handleSubmit = (event) => {
    event.preventDefault();
    // Save the commission data to the database
    dispatch(newProductCommissionCreation(commissiondata));
    Swal.fire({
      title: 'Success!',
      text: 'Commission Added Successfully',
      icon: 'success',
      confirmButtonText: 'Okay'
    })
    if(name == 'Excursion'){
      navigate('/excursionCommissionList/Excursion');

    }else if(name == 'Transfer'){
      navigate('/transferCommissionList/Transfer');
    }else if(name == 'Holiday'){
      navigate('/holidayCommissionList/Holiday');

    }
    

    
  };

  return (
//     <Container className="my-4 mx-4 container-xl ">

// <Card  style={{marginLeft:'100px',marginTop:'-60px'}}>
//       <Card.Header><h4 className="d-flex text-dark text-left mt-2 mb-2">Add Commission Details</h4></Card.Header>
//       <Card.Body>
//           <Row>
//             <Col>

//               <div><span className="badge bg-success" onClick={onBack} style={{ backgroundColor: 'rgb(156 186 237)', color: 'white' , cursor:'pointer'}}><FaArrowLeft />&nbsp;Go Back</span></div>

//             </Col>
//           </Row>
<div className="my-4  container-xl">
                <div className="card" style={{marginTop:'-80px'}}>
                    <div className="card-header">
                        <h3 className="d-flex text-dark text-left mt-2 mb-2"   style={{fontFamily:'Times New Roman' , fontWeight:'600'}}>Add Commission Details</h3>
                    </div>
                    <div className="card-body">
                        <Row>
                            {/* <Link to="/allUsers"><span className="badge bg-success" style={{backgroundColor:'rgb(156 186 237)',color:'white'}}><FaArrowLeft />&nbsp;Go Back</span></Link>  */}
                            <div><span className="badge bg-success" onClick={onBack} style={{ backgroundColor: 'rgb(156 186 237)', color: 'white' , cursor:'pointer'}}><FaArrowLeft />&nbsp;Go Back</span></div>
   
                        </Row>
                        <br />
        <Form className=" mx-4 my-2" component="form" noValidate   autoComplete="off" onSubmit={handleSubmit}> {/* handleOnSubmit() */}

          <Row className="mb-3">
          
           
            
            <Form.Group as={Col} controlId="formGridServiceType">
            <Form.Label>Product Name <span className='text-danger'>*</span></Form.Label>
            <Form.Select  name="productid" required="true" onChange={(e) => handleProductChange(e.target.value)}>
            <option  value="" >Choose</option>
            {products.map((products,index) =>

            <option key={products.id} value={products.id} >{products.product_name}</option>
            )}
            </Form.Select>
            </Form.Group>
            {/* <Form.Group as={Col} controlId="formGridServiceType">
            <Form.Label>Service Type <span className='text-danger'>*</span></Form.Label>
            <Form.Select  name="servicetypeid" disabled={commissiondata.length > 0 ? 0 : 1} required="true" onChange={(e) => handleServtypeChange(e.target.value)}>
            <option  value="" >Choose</option>
            {serviceType.map((service,index) =>
    
            <option key={service.id} value={service.id} >{service.service_type}</option>
            )}
            </Form.Select>
            </Form.Group> */}

            {/* <Form.Group as={Col} controlId="formGridServiceType">
            <Form.Label>Tour Type <span className='text-danger'>*</span></Form.Label>
            <Form.Select  name="tourtypeid" disabled={commissiondata.length > 0 ? 0 : 1} required="true" onChange={(e) => handleTourtypeChange(e.target.value)}>
            <option  value="" >Choose</option>
            {tourType.map((tour,index) =>
    
            <option key={tour.id} value={tour.id} >{tour.tour_type}</option>
            )}
            </Form.Select>
            </Form.Group> */}
           
            {commissiondata?.length > 0 ?<> 
    <div>
         <br />
            <br />
          <Table striped bordered hover>
        <thead>
          <tr>
            <th>Sub Product Name</th>
            <th>Commission Type</th>
            <th>Commission Amount</th>
          </tr>
        </thead>
        <tbody>
          {commissiondata.map((subproduct, index) => (
            <tr key={index}>
              <td>{subproduct.subproduct_name}</td>
              <td><Form.Group as={Col} controlId="formGridStatus">
              <Form.Select required name="status" onChange={(e) => handleComtypeChange( index,e.target.value)}>
                
                <option value="">Choose..</option>
                <option value="Percentage" selected>Percentage</option>
                <option value="Fixed">Fixed</option>
              </Form.Select>
            </Form.Group></td>
              <td>
                <input
                  type="number"
                  min="0"
                  max="100"
                  style={{width:"220px"}}
                  value={subproduct.commission}
                  onChange={(event) =>
                    handleSubproductCommissionChange(
                      index,
                      event.target.value
                    )
                  }
                />
              </td>
            </tr>
          ))}
          <tr>
            <td colSpan={2}>
              <label>
                <input
                  type="checkbox"
                  checked={applyToAll}
                  onChange={handleApplyToAllChange}
                />&nbsp;
                Apply to All
              </label>
            </td>
            <td>
              <input
                type="number"
                min="0"
                max="100"
                value={allCommission}
                // disabled={!applyToAll}
                style={{width:"220px"}}
                onChange={(event) => setAllCommission(event.target.value)}
              />
            </td>
          </tr>
        </tbody>
      </Table>
    </div>
  </> : <><br /><h4 style={{textAlign:"center",color:"red"}}>No Data Found..</h4><br /><p style={{textAlign:"center"}}>[Add Sub Product]</p></>}
          </Row>
          <div class="d-grid  col-2 mx-auto">
          <Button variant="primary" type="submit" disabled={commissiondata?.length === 0} className='align-middle'>
            Submit
          </Button>
          </div>

        </Form>
        </div>
        </div>
        </div>
     
  );
};

export default CreateExcursionCommission;
